import { render, staticRenderFns } from "./cardgrid.vue?vue&type=template&id=2afc9728&scoped=true"
import script from "./cardgrid.vue?vue&type=script&lang=js"
export * from "./cardgrid.vue?vue&type=script&lang=js"
import style0 from "./cardgrid.vue?vue&type=style&index=0&id=2afc9728&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afc9728",
  null
  
)

export default component.exports